import React from 'react';

/**
 * Single-select radio cell. By default all rows in one grid share the same
 * `groupName` so AG Grid's value model holds the selected row id on every row's
 * field (caller updates state accordingly inside onRowChange).
 *
 * For grids with many independent radio groups (e.g. a per-group "default row"
 * selector), pass per-row resolvers `getGroupName(row)`/`getChecked(row)`, which
 * take precedence over the shared `groupName`/`selectedRowId`.
 *
 * cellRendererParams (merged with column.cellProps):
 *   onRowChange(rowId, field, value)
 *   getRowId(row) -> string
 *   groupName          shared radio group name (fallback)
 *   selectedRowId      currently selected row id (fallback)
 *   getGroupName(row)  -> string   per-row group name (optional, overrides groupName)
 *   getChecked(row)    -> boolean  per-row checked state (optional, overrides selectedRowId)
 *   disabled
 */
function RadioCell(params) {
  const { data, colDef, onRowChange, getRowId, groupName, selectedRowId, getGroupName, getChecked, disabled } = params;
  const rowId = getRowId ? getRowId(data) : data?.id;
  const field = colDef?.field;
  const name = typeof getGroupName === 'function' ? getGroupName(data) : groupName;
  const checked = typeof getChecked === 'function' ? getChecked(data) : selectedRowId === rowId;

  return (
    <label className="cag-radio">
      <input type="radio" className="cag-radio-input" name={name} checked={checked} disabled={disabled} onChange={() => onRowChange?.(rowId, field, rowId)} />
    </label>
  );
}

export default RadioCell;
